export default {
  gems: 'gems',
  avatar: 'avatar',
  board: 'board'
};
